import cx from 'clsx';
import { IHeaderProps } from '@paylink/types';
import { Global, Event as PaylinkEvent } from '@paylink/constants';
import { eventManager } from '@paylink/services';

import { Image } from '@shared/components/core';

const Header = ({
	logoId,
	merchantName,
	isMobile,
	className,
}: IHeaderProps) => {
	const handleImageError = () => {
		eventManager.addEvent(PaylinkEvent.BRAND_LOGO_FETCH_FAILED, {
			merchantId: logoId,
			name: merchantName,
		});
	};

	return (
		<div
			className={cx(
				'd-flex items-center gap3 width100',
				{
					'border-bottom1 border-grey2 mt0 px4 py3': isMobile,
					mt8: !isMobile,
				},
				className,
			)}
		>
			<Image
				handleImageError={handleImageError}
				src={`${Global.MERCHANT_LOGO_BASE_URL}${logoId}.png`}
				fallbackImage={Global.MERCHANT_LOGO_FALLBACK}
				alt={merchantName}
				width={40}
				height={40}
				className={cx(' border-radius-full object-cover')}
			/>
			<span className="bolder h3 dark1 lh2">{merchantName}</span>
		</div>
	);
};

export default Header;
